import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';


const CommentItem = ({ comment, onLike, onReply, onReport, depth = 0 }) => {
  const [showReplies, setShowReplies] = useState(false);
  const [isLiked, setIsLiked] = useState(false);

  const handleLike = () => {
    setIsLiked(!isLiked);
    onLike(comment?.id);
  };

  const maxDepth = 2;
  const canReply = depth < maxDepth;

  return (
    <div className={`${depth > 0 ? 'ml-8 md:ml-12' : ''}`}>
      <div className="flex gap-3 md:gap-4">
        <div className="flex-shrink-0">
          <Image
            src={comment?.authorAvatar}
            alt={comment?.authorAvatarAlt}
            className="w-8 h-8 md:w-10 md:h-10 rounded-full object-cover"
          />
        </div>

        <div className="flex-1 min-w-0">
          <div className="bg-muted rounded-2xl px-3 py-2 md:px-4 md:py-3">
            <div className="flex items-center gap-2 mb-1">
              <span className="font-medium caption text-foreground">
                {comment?.author}
              </span>
              {comment?.isVerified && (
                <Icon name="BadgeCheck" size={14} color="var(--color-primary)" />
              )}
              <span className="caption text-muted-foreground">
                {comment?.time}
              </span>
            </div>
            <p className="text-foreground caption leading-relaxed whitespace-pre-wrap">
              {comment?.text}
            </p>
          </div>

          <div className="flex items-center gap-4 md:gap-6 mt-2 px-3">
            <button
              onClick={handleLike}
              className="flex items-center gap-1.5 caption text-muted-foreground hover:text-error transition-base"
              aria-label={isLiked ? "Unlike comment" : "Like comment"}
            >
              <Icon
                name="Heart"
                size={16}
                fill={isLiked ? "currentColor" : "none"}
                className={isLiked ? 'text-error' : ''}
              />
              {comment?.likes > 0 && (
                <span className={isLiked ? 'text-error' : ''}>
                  {comment?.likes}
                </span>
              )}
            </button>

            {canReply && (
              <button
                onClick={() => onReply(comment?.id)}
                className="caption text-muted-foreground hover:text-primary transition-base font-medium"
              >
                Reply
              </button>
            )}

            <button
              onClick={() => onReport(comment?.id)}
              className="caption text-muted-foreground hover:text-foreground transition-base ml-auto"
              aria-label="Report comment"
            >
              <Icon name="Flag" size={16} />
            </button>
          </div>

          {comment?.replies && comment?.replies?.length > 0 && (
            <div className="mt-3 md:mt-4">
              {!showReplies && (
                <button
                  onClick={() => setShowReplies(true)}
                  className="caption text-primary font-medium hover:underline px-3"
                >
                  View {comment?.replies?.length} {comment?.replies?.length === 1 ? 'reply' : 'replies'}
                </button>
              )}

              {showReplies && (
                <div className="space-y-3 md:space-y-4">
                  {comment?.replies?.map((reply) => (
                    <CommentItem
                      key={reply?.id}
                      comment={reply}
                      onLike={onLike}
                      onReply={onReply}
                      onReport={onReport}
                      depth={depth + 1}
                    />
                  ))}
                  <button
                    onClick={() => setShowReplies(false)}
                    className="caption text-muted-foreground hover:text-foreground transition-base px-3"
                  >
                    Hide replies
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommentItem;